(() => {
  'use strict';
  if (customElements.get('tt-comparison')) return;
  customElements.define('tt-comparison', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const range = this.querySelector('input[type="range"]');
      if (!range) return;
      const buttons = [...this.querySelectorAll('[data-position]')];
      const update = () => {
        const value = Number(range.value);
        this.style.setProperty('--tt-position', `${value}%`);
        range.setAttribute('aria-valuetext', `${range.dataset.leftLabel}: ${value}%; ${range.dataset.rightLabel}: ${100 - value}%`);
        buttons.forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.position) === value)));
        this.querySelector('.tt-compare__panel--other figcaption').hidden = value > 85;
        this.querySelector('.tt-compare__panel--femieko figcaption').hidden = value < 15;
      };
      range.addEventListener('input', update, options);
      buttons.forEach(button => button.addEventListener('click', () => { range.value = button.dataset.position; update(); }, options));
      this.classList.add('is-ready');
      this.querySelectorAll('[hidden]').forEach(element => { element.hidden = false; });
      update();
    }
    disconnectedCallback() { this.events?.abort(); }
  });
})();
